import { initializeApp } from "firebase/app";
import { initializeFirestore } from "firebase/firestore";
//import { getAnalytics } from "firebase/analytics";

const config = {
    apiKey: "AIzaSyCG65EB0gojy6cIUO23eJ1gM2mMi7DjLLI",
    authDomain: "docgenda.firebaseapp.com",
    databaseURL: "https://docgenda.firebaseio.com",
    projectId: "docgenda",
    storageBucket: "docgenda.appspot.com",
    messagingSenderId: "659741174605",
    appId: "1:659741174605:web:495b33c5dcbd401e0ae504",
    measurementId: "G-QEWC42M632"
};


const firebaseApp = initializeApp(config);

// Initialize Analytics and get a reference to the service
//export const analytics = getAnalytics(firebaseApp);

// Mobile-specific Firestore configuration
const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

const firestoreSettings = {
    experimentalAutoDetectLongPolling: !isMobile,
    // Additional mobile-specific settings
    cacheSizeBytes: isMobile ? 50 * 1024 * 1024 : 100 * 1024 * 1024, // 50MB for mobile, 100MB for desktop
    ignoreUndefinedProperties: true
};


try {
    initializeFirestore(firebaseApp, firestoreSettings);
} catch (error) {
    console.error("Firebase: Error initializing Firestore:", error);
}

export default firebaseApp;
